import identity from "./identity.js";
import pipe from "./pipe.js";
function evolve(transformation, obj) {
    if (obj === undefined) {
        return (obj) => evolve(transformation, obj);
    }
    return pipe(Object.entries(obj), (entries) => entries.map(([k, v]) => { var _a; return [k, ((_a = transformation[k]) !== null && _a !== void 0 ? _a : identity)(v)]; }), Object.fromEntries);
}
export default evolve;
//# sourceMappingURL=evolve.js.map